import React from 'react';

import { ChevronLeftIcon } from '@/shared/assets/icons/chevron-left-icon';
import { ChevronRightIcon } from '@/shared/assets/icons/chevron-right-icon';
import { StyledTabs } from '@/shared/components/ui/tabs/tabs.styled';
import { TTabsProps } from '@/shared/components/ui/tabs/tabs.types';

export const Tabs: React.FC<TTabsProps> = ({ fullWidth, variant, ...rest }) => {
  const _variant = fullWidth ? 'fullWidth' : variant || 'standard';
  return (
    <StyledTabs
      variant={_variant}
      {...rest}
      slots={{
        StartScrollButtonIcon: (props) => (
          <ChevronLeftIcon {...props} variant="secondary" />
        ),
        EndScrollButtonIcon: (props) => (
          <ChevronRightIcon {...props} variant="secondary" />
        ),
      }}
    />
  );
};
